<!-- ═══ CARROSSEL DE BANNER PRINCIPAL (2 ITENS) ═══ -->
<div class="fc-hero-carousel-wrapper" (mouseenter)="isPaused = true" (mouseleave)="isPaused = false">
  <div class="fc-hero-carousel-slides">

    <!-- ITEM 1 DO CARROSSEL: Banner Atual (Sem Mudar Nada) -->
    <div class="fc-hero-slide" [class.active]="bannerSlideIndex === 0">
      <!-- ═══ HERO SECTION V.3.0 ═══ -->
      <section class="fc-hero">
        <div class="fc-hero-bg-pattern"></div>
        <div class="fc-hero-grid-lines"></div>

        <div class="fc-hero-inner container">
          <!-- COLUNA ESQUERDA: TEXTO & CTAs -->
          <div class="fc-hero-content">
            <div class="fc-hero-eyebrow">
              <span class="fc-hero-eyebrow-dot"></span>
              #1 Plataforma de Crowdfunding em Angola
            </div>

            <h1 class="fc-hero-title">
              {{ header || 'Financie o seu' }} <span class="highlight">sonho.</span><br />
              <span class="underline-green">Angola</span> apoia-te.
            </h1>

            <p class="fc-hero-desc">
              {{
              subTitulo ||
              'Conectamos criadores angolanos com milhares de apoiadores. Lança a tua campanha, partilha a tua visão e
              recebe
              o financiamento que precisas para mudar vidas.'
              }}
            </p>

            <div class="fc-hero-ctas">
              <button type="button" class="btn btn-amber btn-xl btn-rounded" (click)="callRouteCreateCampanha()">
                <i class="fas fa-rocket"></i>
                <span>Lançar Campanha</span>
              </button>

              <a [routerLink]="['/campanhas']" class="btn btn-white btn-xl btn-rounded">
                <i class="fas fa-compass"></i>
                <span>Explorar Projectos</span>
              </a>
            </div>

            <!-- SOCIAL PROOF / TRUST STACK -->
            <div class="fc-hero-trust">
              <div class="fc-hero-trust-avatars">
                <div class="fc-hero-avatar" style="background:#16a34a;">M</div>
                <div class="fc-hero-avatar" style="background:#047857;">A</div>
                <div class="fc-hero-avatar" style="background:#d97706;">J</div>
                <div class="fc-hero-avatar" style="background:#1d4ed8;">L</div>
                <div class="fc-hero-avatar" style="background:#9333ea;">C</div>
              </div>
              <div class="fc-hero-trust-text">
                <strong>+{{stats.totalUtilizador}} angolanos</strong>
                já apoiaram projectos na plataforma
              </div>
            </div>
          </div>

          <!-- COLUNA DIREITA: VISUAL & CARD DESTAQUE -->
          <div class="fc-hero-visual">
            <!-- FLUTUANTE 1: VALOR ARRECADADO DA CAMPANHA ATIVA -->
            <div class="fc-hero-float fc-hero-float-1" [class.pulse-update]="animating">
              <div class="fc-hero-float-icon amber-bg">
                <i class="fas fa-trophy" style="color: #d97706;"></i>
              </div>
              <div>
                <div class="fc-hero-float-title">Valor Arrecadado</div>
                <div class="fc-hero-float-value amber">
                  {{ formatarMoedaFloat(campanhaAtual?.valorArrecado) }}
                </div>
              </div>
            </div>

            <!-- CARD CENTRAL EM DESTAQUE COM ROTAÇÃO -->
            <div class="fc-hero-card-main" (mouseenter)="pauseAutoplay()" (mouseleave)="resumeAutoplay()"
              [class.card-transition]="animating" (click)="irParaCampanha(campanhaAtual)" role="button" tabindex="0"
              (keydown.enter)="irParaCampanha(campanhaAtual)"
              [attr.aria-label]="'Ver detalhes da campanha ' + (campanhaAtual?.titulo || '')"
              title="Clique para ver os detalhes da campanha">

              <!-- Controles de Rotação (Anterior / Próximo & Indicadores) -->
              <div class="fc-card-carousel-header" *ngIf="campanhasDestaque.length > 1"
                (click)="$event.stopPropagation()">
                <div class="fc-card-dots">
                  <span *ngFor="let c of campanhasDestaque; let i = index" class="fc-card-dot"
                    [class.active]="i === currentIndex" (click)="goTo(i, $event)"
                    [title]="c.titulo || 'Campanha'"></span>
                </div>

                <div class="fc-card-nav-actions">
                  <button type="button" class="fc-card-nav-btn" (click)="prev($event)" title="Campanha anterior"
                    aria-label="Campanha anterior">
                    <i class="fas fa-chevron-left"></i>
                  </button>
                  <button type="button" class="fc-card-nav-btn" (click)="next($event)" title="Próxima campanha"
                    aria-label="Próxima campanha">
                    <i class="fas fa-chevron-right"></i>
                  </button>
                </div>
              </div>

              <div class="fc-hero-card-img">
                <!-- Status Badge -->
                <span class="fc-card-status-badge" [class.success]="isCampanhaSucesso(campanhaAtual)"
                  [class.urgent]="campanhaAtual?.expirado && !isCampanhaSucesso(campanhaAtual)"
                  [class.active]="!campanhaAtual?.expirado && !isCampanhaSucesso(campanhaAtual)">
                  <i [class]="isCampanhaSucesso(campanhaAtual) ? 'fas fa-check-circle' : 'fas fa-clock'"></i>
                  <span>{{ isCampanhaSucesso(campanhaAtual) ? 'Meta Atingida' : (campanhaAtual?.expirado ? 'Encerrada' :
                    'Em Andamento') }}</span>
                </span>

                <img [src]="
              campanhaAtual?.imgPreview ||
              campanhaAtual?.fotoUrl ||
              '/images/campanha-1.png'
            " [alt]="campanhaAtual?.titulo || 'Campanha em destaque'" />
              </div>

              <div class="fc-hero-card-body">
                <span class="fc-hero-card-category">
                  <i class="fas fa-heart" style="color: #16a34a;"></i>
                  {{ campanhaAtual?.categoria?.descricao || 'Causa Solidária' }}
                </span>

                <h3 class="fc-hero-card-title line-clamp-2" [title]="limparTexto(campanhaAtual?.titulo)">
                  {{
                  limparTexto(campanhaAtual?.titulo) ||
                  'Campanha em destaque'
                  }}
                </h3>

                <div class="fc-hero-card-org">
                  <i class="fas fa-map-marker-alt"></i>
                  {{
                  campanhaAtual?.provincia?.descricao ||
                  'Luanda, Angola'
                  }}
                </div>

                <div class="fc-hero-progress-label">
                  <span class="amount">
                    {{ formatarMoedaCard(campanhaAtual?.valorArrecado) }}
                  </span>
                  <span class="pct">
                    {{ getPercent(campanhaAtual) }}%
                  </span>
                </div>

                <div class="progress-track" style="margin-bottom: 0.75rem;">
                  <div class="progress-fill" [style.width.%]="getPercent(campanhaAtual)"></div>
                </div>

                <div class="fc-hero-card-meta">
                  <div class="fc-meta-item">
                    <i class="fas fa-users"></i>
                    <span>
                      {{ campanhaAtual?.totalDoadores || 0 }} doadores
                    </span>
                  </div>
                  <div class="fc-meta-item">
                    <i class="fas fa-clock"></i>
                    <span>
                      {{ getDiasRestantesTexto(campanhaAtual) }}
                    </span>
                  </div>
                </div>

                <button type="button" class="btn btn-primary btn-full btn-rounded mt-3"
                  (click)="irParaCampanha(campanhaAtual); $event.stopPropagation()">
                  <i class="fas fa-heart"></i>
                  <span>Financiar Este Projecto</span>
                </button>
              </div>
            </div>

            <!-- FLUTUANTE 2: CAMPANHAS ACTIVAS -->
            <div class="fc-hero-float fc-hero-float-2">
              <div class="fc-hero-float-icon green-bg">
                <i class="fas fa-chart-line" style="color: #16a34a;"></i>
              </div>
              <div>
                <div class="fc-hero-float-title">Campanhas Realizadas</div>
                <div class="fc-hero-float-value">{{stats.totalCampanhas}} Projectos</div>
              </div>
            </div>
          </div>

        </div>
      </section>
    </div>

    <!-- ITEM 2 DO CARROSSEL: Imagem Retornada pelo Serviço getBannerPrincipal (Tela Toda, Sem Dizeres) -->
    <div class="fc-hero-slide fc-hero-slide-image" [class.active]="bannerSlideIndex === 1">
      <section class="fc-hero-fullscreen-banner">
        <div class="fc-hero-banner-backdrop"
          [style.backgroundImage]="bannerPrincipalImg ? 'url(' + bannerPrincipalImg + ')' : (imgPreview ? 'url(' + imgPreview + ')' : 'none')">
        </div>
        <img [src]="bannerPrincipalImg || imgPreview || 'images/campanha-1.png'" alt="Banner Principal FundCube"
          class="fc-hero-img-fullscreen" />
      </section>
    </div>

  </div>

  <!-- NAVEGAÇÃO ENTRE OS 2 ITENS DO BANNER (Anterior / Próximo) -->
  <button type="button" class="fc-hero-carousel-nav prev" (click)="prevBannerSlide($event)" aria-label="Banner anterior"
    title="Banner anterior">
    <i class="fas fa-chevron-left"></i>
  </button>
  <button type="button" class="fc-hero-carousel-nav next" (click)="nextBannerSlide($event)" aria-label="Próximo banner"
    title="Próximo banner">
    <i class="fas fa-chevron-right"></i>
  </button>

  <!-- INDICADORES (DOTS) DO CARROSSEL DE BANNER -->
  <div class="fc-hero-carousel-indicators">
    <button type="button" class="fc-hero-indicator" [class.active]="bannerSlideIndex === 0"
      (click)="goToBannerSlide(0, $event)" aria-label="Item 1: Campanhas em Destaque">
      <span class="indicator-bar"></span>
      <span class="indicator-text">Campanhas</span>
    </button>
    <button type="button" class="fc-hero-indicator" [class.active]="bannerSlideIndex === 1"
      (click)="goToBannerSlide(1, $event)" aria-label="Item 2: Banner Principal">
      <span class="indicator-bar"></span>
      <span class="indicator-text">Destaque</span>
    </button>
  </div>
</div>

<!-- ═══ STATS BAR V.3.0 ═══ -->
<div class="fc-stats-bar">
  <div class="fc-stats-inner container">
    <div class="fc-stat-item">
      <div class="fc-stat-icon green">
        <i class="fas fa-hand-holding-heart"></i>
      </div>
      <div>
        <div class="fc-stat-value">{{ (stats.pagamentosConfirmados || 0) | number:'1.0-0' }}</div>
        <div class="fc-stat-label">Pagamentos Confirmados</div>
      </div>
    </div>

    <div class="fc-stat-item">
      <div class="fc-stat-icon amber">
        <i class="fas fa-bullhorn"></i>
      </div>
      <div>
        <div class="fc-stat-value"> + {{ stats.totalCampanhas }}</div>
        <div class="fc-stat-label">Campanhas Realizadas</div>
      </div>
    </div>

    <div class="fc-stat-item">
      <div class="fc-stat-icon blue">
        <i class="fas fa-users"></i>
      </div>
      <div>
        <div class="fc-stat-value">+ {{ stats.totalUtilizador }}</div>
        <div class="fc-stat-label">Apoiadores</div>
      </div>
    </div>

    <div class="fc-stat-item">
      <div class="fc-stat-icon purple">
        <i class="fas fa-map-marker-alt"></i>
      </div>
      <div>
        <div class="fc-stat-value">{{ stats.totalProvincias || 18 }}</div>
        <div class="fc-stat-label">Províncias Abrangidas</div>
      </div>
    </div>
    <!-- VAI SER USADO DEPOIS -->
    <!-- 
      <div class="fc-stat-item">
      <div class="fc-stat-icon green">
        <i class="fas fa-trophy"></i>
      </div>
      <div>
        <div class="fc-stat-value">{{ stats.taxaSucesso ?? 0 }}%</div>
        <div class="fc-stat-label">Taxa de Sucesso</div>
      </div>
    </div> 
    -->
  </div>